import { render, staticRenderFns } from "./StationOrSensor.vue?vue&type=template&id=05c6cff7&scoped=true"
import script from "./StationOrSensor.vue?vue&type=script&lang=ts"
export * from "./StationOrSensor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6cff7",
  null
  
)

export default component.exports